import { Action, createReducer, on, createFeatureSelector, createSelector } from '@ngrx/store';
import { TransferDetailsActions } from '../actions';


export const transferDetailsFeatureKey = 'transferDetails';

export interface State {
  transferDetails: any;
  transferDetailsFiles: any[];
  transferEvents: any[];
  transferEventsGroupedByEmail: any[];
  transferEventsGroupedByAnonymousUser: any[];
  loadingTransferDetails: boolean;
  loadingTransferDetailsFiles: boolean;
  loadingTransferEvents: boolean;
  transferDeleting: boolean;
  transferDeletingError: any;
  transferDeleted: boolean;
}

export const initialState: State = {
  transferDetails: null,
  loadingTransferDetails: null,
  transferDetailsFiles: [],
  loadingTransferDetailsFiles: null,
  transferEvents: [],
  loadingTransferEvents: null,
  transferEventsGroupedByEmail: [],
  transferEventsGroupedByAnonymousUser: [],
  transferDeleting: false,
  transferDeletingError: null,
  transferDeleted: false,
};

const transferDetailsReducer = createReducer(
  initialState,
  on(TransferDetailsActions.loadTransferDetails, (state) => ({
    ...state,
    transferDetails: null,
    loadingTransferDetails: true
  })),
  on(TransferDetailsActions.loadTransferDetailsSuccess, (state, { transfer }) => ({
    ...state,
    transferDetails: transfer,
    loadingTransferDetails: false
  })),
  on(TransferDetailsActions.loadTransferDetailsFailure, (state, { error }) => ({
    ...state,
    error,
    loadingTransferDetails: false
  })),
  on(TransferDetailsActions.loadTransferDetailsFiles, (state) => ({
    ...state,
    transferDetailsFiles: null,
    loadingTransferDetailsFiles: true
  })),
  on(TransferDetailsActions.loadTransferDetailsFilesSuccess, (state, {  transferFiles }) => ({
    ...state,
    transferDetailsFiles: transferFiles,
    loadingTransferDetailsFiles: false
  })),
  on(TransferDetailsActions.loadTransferDetailsFilesFailure, (state, { error }) => ({
    ...state,
    error,
    loadingTransferDetailsFiles: false
  })),
  on(TransferDetailsActions.loadTransferEvents, (state) => ({
    ...state,
    transferEvents: null,
    transferEventsGroupedByEmail: [],
    transferEventsGroupedByAnonymousUser: [],
    loadingTransferEvents: true
  })),
  on(TransferDetailsActions.loadTransferEventsSuccess, (state, {  events, eventsGroupedByEmailArray, eventsGroupedByAnonymousUserArray }) => ({
    ...state,
    transferEvents: events,
    transferEventsGroupedByEmail: eventsGroupedByEmailArray,
    transferEventsGroupedByAnonymousUser: eventsGroupedByAnonymousUserArray,
    loadingTransferEvents: false
  })),
  on(TransferDetailsActions.loadTransferEventsFailure, (state, { error }) => ({
    ...state,
    error,
    loadingTransferEvents: false
  })),
  on(TransferDetailsActions.loadTransferDetailsFilesSuccess, (state, {  transferFiles }) => ({
    ...state,
    transferDetailsFiles: transferFiles,
    loadingTransferDetailsFiles: false
  })),
  on(TransferDetailsActions.loadTransferDetailsFilesFailure, (state, { error }) => ({
    ...state,
    error,
    loadingTransferDetailsFiles: false
  })),
  on(TransferDetailsActions.deleteTransfer, (state) => ({
    ...state,
    transferDeleting: true,
    transferDeleted: initialState.transferDeleted,
    transferDeletingError: initialState.transferDeletingError,
  })),
  on(TransferDetailsActions.deleteTransferSuccess, (state) => ({
    ...state,
    transferDeleting: initialState.transferDeleting,
    transferDeleted: true,
  })),
  on(TransferDetailsActions.deleteTransferFailure, (state, { error }) => ({
    ...state,
    transferDeleting: initialState.transferDeleting,
    transferDeleted: initialState.transferDeleted,
    transferDeletingError: error,
  })),
);

export function reducer(state: State | undefined, action: Action) {
  return transferDetailsReducer(state, action);
}

export const getTransferDetailsState = createFeatureSelector<State>('transferDetails');


export const getTransferDetails = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferDetails
);

export const getTransferEvents = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferEvents
);

export const getTransferEventsGroupedByEmail = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferEventsGroupedByEmail
);

export const getTransferEventsGroupedByAnonymousUser = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferEventsGroupedByAnonymousUser
);

export const getTransferDetailsFiles = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferDetailsFiles
);

export const getTransfersDetailsLoading = createSelector(
  getTransferDetailsState,
  (state: State) => state.loadingTransferDetails
);

export const getTransfersDetailsFilesLoading = createSelector(
  getTransferDetailsState,
  (state: State) => state.loadingTransferDetailsFiles
);

export const getTransferEventsLoading = createSelector(
  getTransferDetailsState,
  (state: State) => state.loadingTransferEvents
);

export const getTransferDeleting = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferDeleting
);

export const getTransferDeleted = createSelector(
  getTransferDetailsState,
  (state: State) => state.transferDeleted
);